import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'copies_contracts_are_not_provided_workers_line_applicable'

export const dataPointDefinition = {
  retracedId: 'copies_contracts_are_not_provided_workers_line_applicable',
  name: 'Copies of contracts are not provided to workers, in line with applicable legal requirements',
  description: 'Consult applicable legal requirements before answering this question. ',
  meta: {
    slcpMeta: {
      key: 'rh-emp-16',
      number: 'RH-EMP-11-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-16', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34450,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
